import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, filter, finalize, Observable, take } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import {
  GetAddressBookResponse,
  SaveAddressbookRequest,
  SaveAddressBookResponse,
} from 'src/app/core/models/operations/address-book.model';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { environment } from 'src/environments/environment';
import { ErrorhandleService } from '../../error-handling/error-handle/errorhandle.service';

@Injectable({
  providedIn: 'root',
})
export class AddressBookService {
  baseUrl = environment.apiUrl.concat('operations-management');

  constructor(
    private readonly http: HttpClient,
    private readonly commonUtils: CommonUtils,
    private readonly errorHandler: ErrorhandleService,
  ) {}

  getAddressBook(
    consigneeName?: string,
    address?: string,
    city?: string,
    route?: string,
  ): Observable<GetAddressBookResponse> {
    this.commonUtils.updateLoadingModal(true);

    const params: any = {};
    params.customerName = consigneeName;
    params.route = route;
    params.streetName = address;
    params.city = city;

    return this.http
      .get<GetAddressBookResponse>(`${this.baseUrl}/searchcustomer`, {
        params,
      })
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<GetAddressBookResponse>(
            error,
            error.status,
            'Operations Management Service: Get Address Book',
            BANNER_TYPE.API_400_ERROR,
            error,
          ),
        ),
        filter((value) => !!value),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }

  saveToAddressBook(
    addressBook: SaveAddressbookRequest,
  ): Observable<SaveAddressBookResponse> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .post<SaveAddressBookResponse>(
        `${this.baseUrl}/savecustomer`,
        addressBook,
      )
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<SaveAddressBookResponse>(
            error,
            error.status,
            'Operations Managment Service: Save to Address Book',
            BANNER_TYPE.API_400_ERROR,
            error,
          ),
        ),
        filter((value) => !!value),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }
}
